export const redux_getAllLeads = (data: any) => ({
    type: 'GET_ALL_LEADS',
    payload: data,
});

export const redux_getLead = (data: any) => ({
    type: 'GET_LEAD',
    payload: data,
});

export const redux_updateLead = (data: any) => ({
    type: 'UPDATE_LEAD',
    payload: data,
});

export const redux_createLead = (data: any) => ({
    type: 'CREATE_LEAD',
    payload: data,
});

export const redux_leadActionStarts = () => ({
    type: 'LEAD_ACTION_STARTS',
});

export const redux_leadActionErrors = (error: string) => ({
    type: 'LEAD_ACTION_ERRORS',
    payload: error,
});

export const redux_resetLeadErrors = () => ({
    type: 'RESET_LEAD_ERRORS',
}); 